import React from 'react';
import { useMsal } from '@azure/msal-react';
import './Home.css';

const Home = () => {
    const { accounts } = useMsal();

    // Enhanced styles for a more professional layout
    const styles = {
        container: {
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            minHeight: '100vh',
            textAlign: 'center',
            padding: '20px',
            paddingTop: '60px',
        },
        card: {
            backgroundColor: 'white',
            borderRadius: '12px',
            boxShadow: '0 8px 16px rgba(0,0,0,0.1)',
            padding: '40px',
            maxWidth: '700px', // Updated to match Profile page width
            width: '100%',
            margin: '0 auto',
        },
        heading: {
            fontSize: '2.5rem',
            marginBottom: '20px',
            color: '#333',
            fontWeight: '600',
        },
        welcome: {
            fontSize: '1.3rem',
            marginBottom: '30px',
            color: '#555',
        },
        contentSection: {
            marginTop: '30px',
            textAlign: 'left',
            padding: '20px',
            backgroundColor: '#f8f9fa',
            borderRadius: '8px',
        },
        sectionHeading: {
            fontSize: '1.8rem',
            marginBottom: '15px',
            color: '#444',
        },
        paragraph: {
            fontSize: '1.1rem',
            lineHeight: '1.5',
            color: '#555',
        },
        footer: {
            marginTop: '30px',
            fontSize: '0.9rem',
            color: '#6c757d',
        }
    };
    
    return (
        <div style={styles.container}>
            <div style={styles.card}>
                <h1 style={styles.heading}>Welcome</h1>
                <p style={styles.welcome}>Hello, {accounts[0].name}!</p>
                
                <div style={styles.contentSection}>
                    <h2 style={styles.sectionHeading}>Protected Content</h2>
                    <p style={styles.paragraph}>This content is only visible to authenticated users (you).</p>
                </div>
                
            </div>
        </div>
    );
};

export default Home;